/**
 * @file 顶部导航栏的数据
 * @author wanzhongyun
 */
import UrlPattern from 'url-pattern';

export interface IMenuDataTagsItem {
    color: 'red' | 'green' | 'blue';
    text: string;
}

export interface IMenuDataItem {
    key: string;
    title: string;
    url?: string;
    urlPattern?: string | string[];
    urlPatternExclude?: string | string[];
    tags?: IMenuDataTagsItem[];
    target?: string | boolean;
    children?: IMenuDataItem[];
}

// 根据 url 设置唯一key
const setKeyFromObj = (item: IMenuDataItem[]): IMenuDataItem[] => {
    return item.map((subItem, index) => {
        if (!subItem.key && subItem.url) {
            subItem.key = subItem.url;
        } else if (!subItem.key && subItem.title) {
            subItem.key = `$${subItem.title}`;
        } else if (!subItem.key) {
            subItem.key = `$${index}`;
        }
        if (subItem.children) {
            subItem.children = setKeyFromObj(subItem.children);
        }
        return subItem;
    });
};

const menuData: IMenuDataItem[] = setKeyFromObj([
    {
        key: '',
        title: 'Install',
        url: '/en/install/quick?docurl=/documentation/docs/en/install/pip/macos-pip_en.html',
        urlPattern: '/en/install/**',
        children: []
    },
    {
        key: '',
        title: 'Docs',
        url: '/documentation/docs/en/guides/index_en.html',
        urlPattern: '/documentation/docs/**',
        children: []
    },
    {
        key: '',
        title: 'Models',
        url: 'https://aistudio.baidu.com/aistudio/modelsoverview?lang=en',
        urlPattern: ['/en/models'],
        children: [],
        target: true
    },
    {
        key: '',
        title: 'Products',
        url: '/en/overview',
        urlPattern: '/en/overview',
        children: [
            {
                key: '',
                title: 'Tools & Components',
                children: [
                    {
                        key: '',
                        title: 'PaddleHub',
                        url: 'https://github.com/PaddlePaddle/PaddleHub',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleX',
                        url: 'https://github.com/PaddlePaddle/PaddleX',
                        target: true
                    },
                    {
                        key: '',
                        title: 'VisualDL',
                        url: 'https://github.com/PaddlePaddle/VisualDL',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleCloud',
                        url: 'https://github.com/PaddlePaddle/PaddleCloud',
                        target: true
                    },
                    {
                        key: '',
                        title: 'AutoDL',
                        url: 'https://github.com/PaddlePaddle/AutoDL',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PARL',
                        url: 'https://github.com/PaddlePaddle/PARL',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PALM',
                        url: 'https://github.com/PaddlePaddle/PALM',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleFL',
                        url: 'https://github.com/PaddlePaddle/PaddleFL',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PGL',
                        url: 'https://github.com/PaddlePaddle/PGL',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Paddle Quantum',
                        url: 'https://github.com/PaddlePaddle/Quantum',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleScience',
                        url: 'https://github.com/PaddlePaddle/PaddleScience',
                        target: true,
                        tags: [{ color: 'green', text: 'New' }]
                    },
                    {
                        key: '',
                        title: 'PaddleHelix',
                        url: 'https://github.com/PaddlePaddle/PaddleHelix',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleSleeve',
                        url: 'https://github.com/PaddlePaddle/PaddleSleeve',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleFlow',
                        url: 'https://github.com/PaddlePaddle/PaddleFlow',
                        target: true
                    }
                ]
            },
            {
                key: '',
                title: 'End-to-End Development Kits',
                children: [
                    {
                        key: '',
                        title: 'PaddleOCR',
                        url: 'https://github.com/PaddlePaddle/PaddleOCR',
                        target: true,
                        tags: [{ color: 'red', text: 'Hot' }]
                    },
                    {
                        key: '',
                        title: 'PaddleDetection',
                        url: 'https://github.com/PaddlePaddle/PaddleDetection',
                        target: true,
                        tags: [{ color: 'red', text: 'Hot' }]
                    },
                    {
                        key: '',
                        title: 'PaddleSeg',
                        url: 'https://github.com/PaddlePaddle/PaddleSeg',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleClas',
                        url: 'https://github.com/PaddlePaddle/PaddleClas',
                        target: true
                    },
                    {
                        key: '',
                        title: 'ERNIEKit',
                        url: 'https://github.com/PaddlePaddle/ERNIE',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleGAN',
                        url: 'https://github.com/PaddlePaddle/PaddleGAN',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PLSC',
                        url: 'https://github.com/PaddlePaddle/PLSC',
                        target: true
                    },
                    {
                        key: '',
                        title: 'ElasticCTR',
                        url: 'https://github.com/PaddlePaddle/ElasticCTR',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Parakeet',
                        url: 'https://github.com/PaddlePaddle/Parakeet',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleHelix',
                        url: 'https://github.com/PaddlePaddle/PaddleHelix',
                        target: true
                    }
                ]
            },
            {
                key: '',
                title: 'Basic Model Banks',
                children: [
                    {
                        key: '',
                        title: 'PaddleCV',
                        url: 'https://github.com/PaddlePaddle/models',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleNLP',
                        url: 'https://github.com/PaddlePaddle/PaddleNLP',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleRec',
                        url: 'https://github.com/PaddlePaddle/PaddleRec',
                        target: true
                    },
                    {
                        key: '',
                        title: 'PaddleSpeech',
                        url: 'https://github.com/PaddlePaddle/PaddleSpeech',
                        target: true
                    }
                ]
            },
            {
                key: '',
                title: 'Inference & Deployment',
                children: [
                    {
                        key: '',
                        title: 'PaddleSlim',
                        url: 'https://github.com/PaddlePaddle/PaddleSlim',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Paddle Inference',
                        url: 'https://github.com/PaddlePaddle/Paddle-Inference-Demo',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Paddle Serving',
                        url: 'https://github.com/PaddlePaddle/Serving',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Paddle Lite',
                        url: 'https://github.com/PaddlePaddle/Paddle-Lite',
                        target: true
                    },
                    {
                        key: '',
                        title: 'Paddle.js',
                        url: 'https://github.com/PaddlePaddle/Paddle.js',
                        target: true
                    }
                ]
            },
            {
                key: '',
                title: 'Core Frameworks',
                children: [
                    {
                        key: '',
                        title: 'Paddle',
                        url: 'https://github.com/paddlepaddle/paddle',
                        target: true
                    },
                    {
                        key: '',
                        title: 'FleetAPI',
                        url: 'https://github.com/PaddlePaddle/Fleet',
                        target: true
                    }
                ]
            },
            {
                key: '',
                title: 'Service Platforms',
                children: [
                    {
                        key: '',
                        title: 'EasyDL',
                        url: 'https://ai.baidu.com/easydl/',
                        target: true
                    },
                    {
                        key: '',
                        title: 'BML',
                        url: 'https://cloud.baidu.com/product/bml',
                        target: true
                    },
                    {
                        key: '',
                        title: 'AI Studio',
                        url: 'https://aistudio.baidu.com/aistudio/index?lang=en',
                        target: true
                    }
                ]
            }
        ]
    },
    {
        key: '',
        title: 'Customers',
        url: '/en/customercase',
        urlPattern: '/en/customercase'
    }
]);

export const menuRightData: IMenuDataItem[] = setKeyFromObj([
    {
        key: '',
        title: 'Forum',
        url: 'http://discuss.paddlepaddle.org.cn',
        target: '_blank'
    },
    {
        key: '',
        title: 'GitHub',
        url: 'https://github.com/paddlepaddle/paddle',
        target: '_blank'
    }
]);

// 遍历元素找到当前页面 url 匹配的选项
export const findMenu = (
    theMenuData: IMenuDataItem[],
    targetUrl: string = window.location.href.slice(window.location.origin.length)
): IMenuDataItem[] => {
    let resItem: IMenuDataItem[] = [];
    theMenuData.some(item => {
        // 先匹配 urlPatternExclude 如果匹配上说明这条不是我们需要的记录
        let urlPatternExclude: string[] = [];
        if (Array.isArray(item.urlPatternExclude)) {
            urlPatternExclude = item.urlPatternExclude;
        } else if (typeof item.urlPatternExclude === 'string') {
            urlPatternExclude = [item.urlPatternExclude];
        }
        const patternExcludeMatch = urlPatternExclude.some(urlpatt => !!new UrlPattern(urlpatt).match(targetUrl));
        if (patternExcludeMatch) {
            return false;
        }

        // 再匹配 urlExclude，如果匹配上说明这是我们需要的记录
        let urlPattern: string[] = [];
        if (Array.isArray(item.urlPattern)) {
            urlPattern = item.urlPattern;
        } else if (typeof item.urlPattern === 'string') {
            urlPattern = [item.urlPattern];
        }

        const patternMatch = urlPattern.some(urlpatt => {
            if (new UrlPattern(urlpatt).match(targetUrl)) {
                resItem.push(item);
                return true;
            }
            return false;
        });
        if (patternMatch) {
            return true;
        }

        // 如果都没匹配到，则去递归遍历子节点
        if (item.children) {
            const subResItem = findMenu(item.children, targetUrl);
            if (subResItem.length) {
                resItem.push(item);
                subResItem.forEach(childItem => {
                    resItem.push(childItem);
                });
                return true;
            }
        }
        return false;
    });
    return resItem;
};

export default menuData;
